var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header"},[_c('Header',{attrs:{"title":"售后帮助"}})],1),_c('div',{staticClass:"container"},[(_vm.showCsBtn)?_c('Cell',{attrs:{"title":"联系客服","is-link":""},on:{"click":_vm.goCs}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }